import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedMaterialModule } from '@egret/shared/shared-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SearchModule } from '@egret/shared/search/search.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoaderComponent } from 'bookraw/shared/components/loader/loader.component';

// ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT
import { HeaderTopComponent } from '@egret/shared/components/header-top/header-top.component';
import { SidebarTopComponent } from '@egret/shared/components/sidebar-top/sidebar-top.component';

// ALWAYS REQUIRED
import { AdminLayoutComponent } from '@egret/shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from '@egret/shared/components/layouts/auth-layout/auth-layout.component';
import { NotificationsComponent } from '@egret/shared/components/notifications/notifications.component';
import { FooterComponent } from '@egret/shared/components/footer/footer.component';
import { BreadcrumbComponent } from '@egret/shared/components/breadcrumb/breadcrumb.component';
import { AppComfirmComponent } from '@egret/shared/services/app-confirm/app-confirm.component';
import { AppLoaderComponent } from '@egret/shared/services/app-loader/app-loader.component';
import { ButtonLoadingComponent } from '@egret/shared/components/button-loading/button-loading.component';
import {
  EgretSidebarComponent,
  EgretSidebarTogglerDirective
} from '@egret/shared/components/egret-sidebar/egret-sidebar.component';
import { BottomSheetShareComponent } from '@egret/shared/components/bottom-sheet-share/bottom-sheet-share.component';
import { ExtMaterialTableComponent } from 'bookraw/shared/components/ext-material-table/ext-material-table.component';

import { SidenavComponent } from 'bookraw/shared/components/sidenav/sidenav.component';
import { SidebarSideComponent } from 'bookraw/shared/components/sidebar-side/sidebar-side.component';
import { HeaderSideComponent } from 'bookraw/shared/components/header-side/header-side.component';
import { BookrawSharedDirectivesModule } from 'bookraw/shared/directives/shared-directives.module';
import { BookrawSharedPipesModule } from 'bookraw/shared/pipes/shared-pipes.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DialogModule } from 'bookraw/shared/components/dialog/dialog.module';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AudioPlayerComponent } from 'bookraw/shared/components/audio-player/audio-player.component';
import {
  StatisticsCalendarComponent
} from 'bookraw/shared/components/statistics-calendar/statistics-calendar.component';
import { GoalSettingsComponent } from 'bookraw/shared/components/goal-settings/goal-settings.component';
import { FormInputModule } from 'bookraw/shared/components/form-input/form-input.module';
import { Ico54Component } from 'bookraw/shared/components/reusable-components/ico54/ico54.component';

const components = [
  HeaderTopComponent,
  SidebarTopComponent,
  NotificationsComponent,
  // módosított sidenav, custom icons
  SidenavComponent,
  // módosított sidebar, a felesleges gombok ki lettek szedve
  SidebarSideComponent,
  // módosított header komponens, ki lett szedve a nyelvváltó, keresés stb
  HeaderSideComponent,
  AdminLayoutComponent,
  AuthLayoutComponent,
  BreadcrumbComponent,
  AppComfirmComponent,
  AppLoaderComponent,
  ButtonLoadingComponent,
  EgretSidebarComponent,
  FooterComponent,
  EgretSidebarTogglerDirective,
  BottomSheetShareComponent,
  LoaderComponent,
  ExtMaterialTableComponent,
  AudioPlayerComponent,
  StatisticsCalendarComponent,
  GoalSettingsComponent,
  Ico54Component,
];

@NgModule({
  imports: [
    RouterModule,
    TranslateModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    SearchModule,
    BookrawSharedPipesModule,
    BookrawSharedDirectivesModule,
    SharedMaterialModule,
    NgxDatatableModule,
    DialogModule,
    FormsModule,
    MatIconModule,
    FormInputModule,
  ],
  declarations: components,
  entryComponents: [
    AppComfirmComponent,
    AppLoaderComponent,
    BottomSheetShareComponent,
  ],
  exports: components,
})
export class BookrawSharedComponentsModule {}
